import React from 'react';
import classNames from 'classnames';

import { LocaleString } from '@biw/intl';
import { ProgramModel } from '@biw/contests-core/lib/dux/programs';

import './pill-bar.scss';

const getCode = ( id: string, program: ProgramModel ) => {
    if ( id === 'progress' ) {
        if (program.isGoalSelection) {
            return 'paxProgress.navbar.goalSelectionLabel';
        } else if (program.missedGoalSelection) {
            return 'paxProgress.navbar.noGoalSelectedLabel';
        } else if (!program.hasProgress) {
            return program.isObjectives && !program.programHasStarted ?
                'paxProgress.navbar.noProgressLabel' :
                'paxProgress.navbar.progressLabel';
        } else {
            return program.isFinalResults ?
                'paxProgress.navbar.finalResultsLabel' :
                'paxProgress.navbar.progressLabel';
        }
    } else {
        return `paxProgress.navbar.${ id }Label`;
    }
};

export interface ProgressNavBarLinkProps {
    handleNavBarClick: any;
    program: ProgramModel;
    activeLink: string;
}

interface Props extends ProgressNavBarLinkProps {
    id: string;
}

const ProgressNavBarLink = ( { handleNavBarClick, id, program, activeLink }: Props ) => {
    const classes = classNames( {
        'btn-scroll': true,
        'active': activeLink === id,
        'branding-primary-button': activeLink === id,
    } );

    return (
        <li role="menuitem">
            <a href={`#${ id }`} className={classes} onClick={handleNavBarClick} data-sel={`progress-nav-bar-${id}`}>
                <LocaleString code={getCode( id, program )} />
            </a>
        </li>
    );
};

export default ProgressNavBarLink;
